export default __webpack_public_path__ + "static/media/svg-10.8234d160.svg";